import * as React from 'react'

import { useVersionComparisonStore } from '../store'

/**
 * Hook to check if all comparison versions are ready to use
 *
 * Returns true only when all versions in compareVersions have isReady === true.
 * By default, if any layout is not ready, features should not be enabled.
 *
 * @returns boolean indicating if all versions are ready
 */
export const useAllVersionsReady = (): boolean => {
  const { compareVersions } = useVersionComparisonStore()

  return React.useMemo(() => {
    // If no versions, not ready
    if (!compareVersions || compareVersions.length === 0) return false

    // Check if all versions are ready
    return compareVersions.every((version) => version.isReady === true)
  }, [compareVersions])
}
